import { purgeChatMediaOnLogout } from "./chatMediaCache";
import { clearSharedChatRequests } from "./chatSharedRequests";
const API_BASE = (process.env.REACT_APP_API_URL || "/api/v1").replace(/\/$/, "");

const AUTH_KEYS = [
  "token", "role", "name", "admin_id", "supervisor_id", "advisor_id",
  "supporter_id", "student_phone", "guest_phone", "parent_phone", "parent_name",
  "question_designer_id",
];

export function clearAuthSession() {
  clearSharedChatRequests();
  purgeChatMediaOnLogout();
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function logoutAndRedirect(delay = 0) {
  const token = localStorage.getItem("token");

  // Local logout must never wait for the network, PushManager or a service
  // worker that has not taken control of the page yet.
  clearAuthSession();
  window.setTimeout(() => { window.location.replace("/auth/login"); }, Math.max(0, delay));

  if (!token) return Promise.resolve();

  const cleanup = () => {
    // Start both cleanup branches before navigation. keepalive lets their HTTP
    // requests finish after the login page starts loading.
    const revokeSession = fetch(`${API_BASE}/auth/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        keepalive: true,
      }).catch(() => undefined);

    const removePushSubscription = (async () => {
      const registration = "serviceWorker" in navigator
        ? await navigator.serviceWorker.getRegistration()
        : null;
      const subscription = registration ? await registration.pushManager?.getSubscription() : null;
      if (subscription) {
        await fetch(`${API_BASE}/push/subscribe`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ endpoint: subscription.endpoint }),
          keepalive: true,
        });
        await subscription.unsubscribe();
      }
    })().catch(() => undefined);

    return Promise.allSettled([revokeSession, removePushSubscription]);
  };

  return cleanup();
}

export { API_BASE };
